import React, { useState } from "react";
import {
  FaEnvelope,
  FaLinkedin,
  FaFacebook,
  FaGithub,
  FaWhatsapp,
} from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  // Pour la démo, le formulaire ne fait qu'afficher une alerte
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Envoi en cours...");
    try {
      const res = await fetch("https://formspree.io/f/xovwqeqe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });
      if (res.ok) {
        setStatus("Message envoyé ! Merci.");
        setForm({ name: "", email: "", message: "" });
      } else {
        setStatus("Erreur lors de l'envoi.");
      }
    } catch {
      setStatus("Erreur lors de l'envoi.");
    }
  };

  return (
    <section className="contact-section">
      <h2>Contact</h2>
      <div className="contact-container">
        {/* Formulaire à gauche */}
        <div className="contact-form">
          <h3>Envoyez-moi un message</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Votre nom"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Votre email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Votre message"
              value={form.message}
              onChange={handleChange}
              required
            />
            <button type="submit">Envoyer</button>
          </form>
          {status && <div className="contact-status">{status}</div>}
        </div>

        {/* Coordonnées à droite */}
        <div className="contact-info">
          <h3>Mes coordonnées</h3>
          <ul>
            <li>
              <FaEnvelope className="contact-icon" />
              <a href="mailto:rajomampiononarakotoniaina@gmail.com">
                rajomampiononarakotoniaina@gmail.com
              </a>
            </li>
            <li>
              <FaWhatsapp className="contact-icon" />
              <a href="tel:+261342436126">+261 (0) 34 24 361 26</a>
            </li>
            <li>
              <FaLinkedin className="contact-icon" />
              <a
                href="https://www.linkedin.com/in/rajo-mampionona-rakotoniaina-380882367/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <FaFacebook className="contact-icon" />
              <a
                href="https://www.facebook.com/rajo.mampionona.rakotoniaina"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <FaGithub className="contact-icon" />
              <a
                href="https://github.com/kasteh"
                target="_blank"
                rel="noopener noreferrer"
              >
                Github
              </a>
            </li>
          </ul>
          <div className="contact-address">
            <strong>Adresse :</strong>
            <br />
            Lot Lot III G 2 D Ambatolampy, 101, Antananarivo, Madagascar
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
